import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import GlossaryPage from '@/pages/organizations/detail/sets/detail/glossary'
import { find } from 'lodash'

export const Route = createFileRoute('/app/organizations/$organizationId/sets/$setId/glossary')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { setId } = Route.useParams()
  const { organization, assessments } = useOrganization()

  const assessment = find(assessments, (_a) => Number(_a.id) === Number(setId))

  if (!assessment) return null

  return <GlossaryPage organization={organization} assessment={assessment} />
}
